import { Paper, LoadingOverlay, Group, Text, Button, Table, Badge, ActionIcon } from '@mantine/core';
import { IconPlus, IconEdit, IconTrash, IconEye } from '@tabler/icons-react';
import AddUserModal from '../AddUserModal';

export default function UsersSettingsSection({
  loading,
  activeTab,
  users,
  openAddUser,
  addUserOpened,
  closeAddUser,
  fetchUsers,
  openEditUser,
  handleDeleteUser,
  handleViewDetail,
}) {
  return (
    <>
      <Paper withBorder p="md" radius="md" mt="xs" pos="relative">
        <LoadingOverlay visible={loading && activeTab === 'users'} overlayProps={{ radius: 'sm', blur: 2 }} />

        <Group justify="space-between" mb="md">
          <Text fw={700}>Sistem Kullanıcıları</Text>
          <Button size="xs" leftSection={<IconPlus size={14} />} onClick={openAddUser}>
            Yeni Kullanıcı Ekle
          </Button>
        </Group>

        <Table striped highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Kullanıcı Adı</Table.Th>
              <Table.Th>Ad Soyad</Table.Th>
              <Table.Th>E-posta</Table.Th>
              <Table.Th>Rol</Table.Th>
              <Table.Th>Durum</Table.Th>
              <Table.Th style={{ textAlign: 'right' }}>İşlem</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {users.map((user) => (
              <Table.Tr key={user.id}>
                <Table.Td fw={500}>{user.username}</Table.Td>
                <Table.Td>{user.full_name || '-'}</Table.Td>
                <Table.Td>{user.email}</Table.Td>
                <Table.Td>
                  <Badge color={user.role === 'admin' ? 'red' : 'blue'}>{user.role}</Badge>
                </Table.Td>
                <Table.Td>
                  {user.is_active ? <Badge color="green" dot={true}>Aktif</Badge> : <Badge color="gray">Pasif</Badge>}
                </Table.Td>
                <Table.Td style={{ textAlign: 'right' }}>
                  <Group gap="xs" justify="flex-end">
                    <ActionIcon color="dark" variant="subtle" title="Detay" onClick={() => handleViewDetail(user, 'user')}>
                      <IconEye size={16} />
                    </ActionIcon>
                    <ActionIcon color="blue" variant="subtle" onClick={() => openEditUser(user)}>
                      <IconEdit size={16} />
                    </ActionIcon>
                    <ActionIcon color="red" variant="subtle" onClick={() => handleDeleteUser(user.id)}>
                      <IconTrash size={16} />
                    </ActionIcon>
                  </Group>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Paper>

      <AddUserModal opened={addUserOpened} close={closeAddUser} onSuccess={fetchUsers} />
    </>
  );
}